(function () {
  function initHero(root) {
    if (root.dataset.iqReady) return;
    root.dataset.iqReady = '1';
    var slides = root.querySelectorAll('.iq-hero__slide');
    var count = root.querySelector('[data-iq-count]');
    if (slides.length < 2) return;
    var i = 0, timer;
    function show(n) {
      slides[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active');
      if (count) count.textContent = ('0' + (i + 1)).slice(-2) + ' / ' + ('0' + slides.length).slice(-2);
    }
    function auto() {
      clearInterval(timer);
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = setInterval(function () { show(i + 1); }, 6500);
    }
    var prev = root.querySelector('[data-iq-prev]');
    var next = root.querySelector('[data-iq-next]');
    if (prev) prev.addEventListener('click', function () { show(i - 1); auto(); });
    if (next) next.addEventListener('click', function () { show(i + 1); auto(); });
    auto();
  }

  function initLook(root) {
    if (root.dataset.iqReady) return;
    root.dataset.iqReady = '1';
    var dots = root.querySelectorAll('[data-iq-look]');
    var items = root.querySelectorAll('.iq-look__item');
    function set(n) {
      dots.forEach(function (d) { d.classList.toggle('is-active', d.dataset.iqLook === n); });
      items.forEach(function (it) { it.classList.toggle('is-active', it.dataset.iqLook === n); });
    }
    dots.forEach(function (d) { d.addEventListener('click', function () { set(d.dataset.iqLook); }); });
    items.forEach(function (it) {
      it.addEventListener('mouseenter', function () { set(it.dataset.iqLook); });
      it.addEventListener('focusin', function () { set(it.dataset.iqLook); });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-iq-hero]').forEach(initHero);
    (scope || document).querySelectorAll('[data-iq-look-root]').forEach(initLook);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
